module.exports = __webpack_public_path__ + "static/img/Nick-Blakey.f75fc54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nick-Blakey.jpg
// module id = 8Fa1
// module chunks = 0